export * from './colors';

export const values = {
  TIMEOUT_DELAY: 0.3,
  MESSAGE_TIMEOUT: 6000,
};
